import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tdl-page" }
const _hoisted_2 = {
  key: 0,
  class: "tdl-banner"
}
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["srcset"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "tdl-header" }
const _hoisted_7 = { class: "tb-wrap tb-narrow" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Book A Test Drive")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("sup", null, "[DI]", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "tdl-body" }
const _hoisted_16 = { class: "tb-wrap" }
const _hoisted_17 = {
  key: 0,
  class: "tdl-row"
}
const _hoisted_18 = {
  key: 0,
  class: "tdl-col"
}
const _hoisted_19 = ["aria-pressed", "onClick"]
const _hoisted_20 = ["aria-hidden"]
const _hoisted_21 = { class: "tdl-col" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h2", null, "Thank you for your enquiry!", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, "A member of our friendly team will be in touch.", -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["data-url", "onClick"]

import { v4 as uuidv4 } from "uuid";
	import { onMounted, ref, computed, watch, reactive } from 'vue';
	import { useStore } from 'vuex';
	import ChooseVehicleItem from '@/components/ChooseVehicle/ChooseVehicleItem.vue';
	import DetailContactForm from '@/DetailApp/DetailContactForm.vue';
	import LoadingAnimation from '@/components/LoadingAnimation.vue';
	import { convertVehicleToTestDriveOption, convertFactoryOptionToTestDriveOption, getAllGradesFromTree, getCookie, getNewFactoryOptionArrayFromTree } from "@/helpers";
	import { IContactFormValues, IStoreState, ISupplierNavItem, ITestDriveOption, ITree, IVehicle, IWindowScripts } from '@/types';
	import { EFormType, EFormTheme } from '@/enums';
	import { getSupplierNav, getTree } from "@/api";

	
export default /*#__PURE__*/_defineComponent({
  name: 'TestDriveLead',
  props: {
    custom: null,
    bannerDesktop: null,
    bannerDesktopWidth: null,
    bannerDesktopMedia: null,
    bannerMobile: null,
    bannerMobileWidth: null,
    bannerMobileMedia: null,
    showVehicleDetails: null,
    showGradeSelector: null,
    heading: null,
    subheading: null,
    disclaimers: null
  },
  setup(__props: any) {

const props = __props as {
		custom?: string,
		bannerDesktop?: string,
		bannerDesktopWidth?: string,
		bannerDesktopMedia?: string,
		bannerMobile?: string,
		bannerMobileWidth?: string,
		bannerMobileMedia?: string,
		showVehicleDetails?: string,
		showGradeSelector?: string,
		heading?: string,
		subheading?: string,
		disclaimers?: string
	}

	const uid = uuidv4();
	const store = useStore<IStoreState>();
	

	const isLoading = ref<boolean>(true);
	const chosenTestDriveVehicle = ref<ITestDriveOption | null>(null);
	const hasSubmittedTestDriveForm = ref<boolean>(false);
	const section = ref(null);
	const isTileHidden = ref<boolean>(true);
	const nviUrl = ref<string>('');
	const tree = ref<ITree | null>(null);

	const contactFormValues = reactive<IContactFormValues>({
		location: '',
		firstName: '',
		lastName: '',
		email: '',
		phone: '', 
		date: '', 
		time: '',
		additional: '',
		tradeIn: '',
		grade: '',
		exploreFinance: '', 
		terms: [], 
		recaptcha: ''
	});

	const isCustom = computed((): boolean => props.custom == "true");
	const bannerDesktop = computed((): string => props.bannerDesktop || '');
	const bannerDesktopWidth = computed((): string => props.bannerDesktopWidth || '');
	const bannerDesktopMedia = computed((): string => props.bannerDesktopMedia || '');
	const bannerMobile = computed((): string => props.bannerMobile || '');
	const bannerMobileWidth = computed((): string => props.bannerMobileWidth || '');
	const bannerMobileMedia = computed((): string => props.bannerMobileMedia || '');
	const showVehicleDetails = computed((): boolean => typeof props.showVehicleDetails == 'string' ? props.showVehicleDetails.toLowerCase() == "true" : true);
	const showGradeSelector = computed((): boolean => typeof props.showGradeSelector == 'string' ? props.showGradeSelector.toLowerCase() == "true" : false);
	const heading = computed((): string => props.heading || '');
	const subheading = computed((): string => props.subheading || '');
	const disclaimers = computed((): Array<string> => typeof props.disclaimers == 'string' ? JSON.parse(props.disclaimers) : []);
	const gradeNames = computed((): Array<string> => {
		if (!tree.value) return [];
		return getAllGradesFromTree(tree.value);
	});

    const iconCircleTick = computed(() => require('@/assets/icons/icon-circle-tick.svg'));
	const token = computed(() => store.state.DetailApp.form_token);
	const vehicle = computed((): IVehicle => store.state.DetailApp.vehicle);
	const images = computed(() => store.state.DetailApp.images);
	const openingInfo = computed(() => store.state.DetailApp.openingInfo);
	const vehicleLine = computed(() => vehicle.value.VehicleLine);

	const handleToggleClick = (): void => {
		isTileHidden.value = !isTileHidden.value;
	}
	const setChosenTestDriveVehicle = (): void => {
		if (images.value.DefaultFrame){
			chosenTestDriveVehicle.value = convertVehicleToTestDriveOption(vehicle.value, images.value);
			chosenTestDriveVehicle.value.IsTfy = true;
			isLoading.value = false;
		}
		else if (tree.value){
			const newFactoryOptionArr = getNewFactoryOptionArrayFromTree(tree.value);
			if (!newFactoryOptionArr.length) return;
			console.log('newFactoryOptionArr',newFactoryOptionArr);
			chosenTestDriveVehicle.value = convertFactoryOptionToTestDriveOption(newFactoryOptionArr[0]);
			chosenTestDriveVehicle.value.IsTfy = true;
			isLoading.value = false;
		}
	};
	const handleFormStart = () => {
		sendFormStartAnalytics();
	}
	const handleFormUpdate = (vals: IContactFormValues) => {
		for (const prop in vals){
			(contactFormValues as any)[prop] = (vals as any)[prop];
		}
	};
	const handleFormSubmit = () => {
		hasSubmittedTestDriveForm.value = true;
		sendFormSubmitAnalytics();
		scrollToTop(null);
	};
	const scrollToTop = (offset: number | null) => {
		const el: HTMLElement | null = (section.value as any);
		if (!el) return;
		const top = el.getBoundingClientRect().top + (offset || 0) + window.scrollY;
		window.scrollTo({
			top: top, 
			behavior: 'smooth'
		});
	}
	const sendFormStartAnalytics = (): void => {
		const dataLayer = (window as any).dataLayer || [];
		const sb = (window as unknown as IWindowScripts).specBuilder;

		// dataLayer.push({
		// 	event: isCustom.value ? "form_submit_book_a_test_drive_new" : "form_submit_test_drive_booking_new",
		// 	form_name: isCustom.value ? `${vehicleLine.value} Take Home Test Drive` : "Test Drive Booking New",
		// 	has_tpr_applied: sb.HasTprApplied ? 'Yes' : 'No',
		// 	page_type: isCustom.value ? `${vehicleLine.value} Take Home Test Drive Landing Page` : sb.PageType,
		// 	tpr_case_id: getCookie('tprcaseid') || '(not set)',
		// 	vehicle_description: sb.FullDescription || '(not set)',
		// 	vehicle_grade: sb.Grade || '(not set)',
		// 	vehicle_model: sb.VehicleLine,
		// });

		dataLayer.push({
			event: isCustom.value ? "form_start_book_a_test_drive_new" : "form_start_test_drive_booking_new",
			form_name: isCustom.value ? `${vehicleLine.value} Take Home Test Drive` : "Test Drive Booking New",
			// has_tpr_applied: sb.HasTprApplied ? 'Yes' : 'No',
			page_type: isCustom.value ? `${vehicleLine.value} Take Home Test Drive Landing Page` : sb.PageType,
			tpr_case_id: getCookie('tprcaseid') || '(not set)',
			vehicle_description: sb.FullDescription || '(not set)',
			vehicle_grade: sb.Grade || '(not set)',
			vehicle_model: sb.VehicleLine,
		});
	};
	const sendFormSubmitAnalytics = (): void => {
		const dataLayer = (window as any).dataLayer || [];
		const sb = (window as unknown as IWindowScripts).specBuilder;
		dataLayer.push({
			event: isCustom.value ? "form_submit_book_a_test_drive_new" : "form_submit_test_drive_booking_new",
			form_name: isCustom.value ? `${vehicleLine.value} Take Home Test Drive` : "Test Drive Booking New",
			has_tpr_applied: sb.HasTprApplied ? 'Yes' : 'No',
			page_type: isCustom.value ? `${vehicleLine.value} Take Home Test Drive Landing Page` : sb.PageType,
			tpr_case_id: getCookie('tprcaseid') || '(not set)',
			vehicle_description: sb.FullDescription || '(not set)',
			vehicle_grade: sb.Grade || '(not set)',
			vehicle_model: sb.VehicleLine,
		});
	};
	const handleBrowseClick = (): void => {
		(location as any) = nviUrl.value;
	};
	const getNviUrl = async (): Promise<any> => {
		const res = await getSupplierNav(vehicle.value.Dealer.DealerId);
		res.forEach((o: ISupplierNavItem) => {
			if (o.vlUr == vehicle.value.VehicleLine.toLowerCase().replace(/\s/g, '-')){
				nviUrl.value = o.url;
			}
		});
	}

	onMounted(async () => {
		var toggle = document.querySelector('.tdl-tile-toggle');
		if (toggle){
			var style = window.getComputedStyle(toggle);
			if (style.display != 'none'){
				isTileHidden.value = false;
			}
		}
		setChosenTestDriveVehicle();
		getNviUrl();
		if (isCustom.value){
			isLoading.value = true;
			tree.value = await getTree(vehicle.value.VehicleLine, (window as any).PricingZone);
			setChosenTestDriveVehicle();
			isLoading.value = false;
		}
		if (disclaimers.value.length){
			const disclaimerDiv = document.querySelector('.tb-detail-disclaimers .content');
			for (let x = 0; x != disclaimers.value.length; ++x){
				const newP: HTMLElement = document.createElement('p');
				newP.setAttribute('data-dynamic-disclaimer', `tdl-custom-${x}`);
				newP.innerHTML = disclaimers.value[x];
				(disclaimerDiv as HTMLElement).appendChild(newP);
			}
		}
	});

	watch(images, () => {
		setChosenTestDriveVehicle();
	});
	watch(tree, () => {
		setChosenTestDriveVehicle();
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "section",
    ref: section,
    "data-test": "test"
  }, [
    _createVNode(LoadingAnimation, {
      loading: isLoading.value,
      height: 80
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_unref(bannerDesktop) || _unref(bannerMobile))
            ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                _createElementVNode("picture", null, [
                  _createElementVNode("source", {
                    media: "(min-width: 768px)",
                    width: "1920",
                    srcset: _unref(bannerDesktop)
                  }, null, 8, _hoisted_3),
                  _createElementVNode("source", {
                    media: "(max-width: 767px)",
                    width: "780",
                    srcset: _unref(bannerMobile)
                  }, null, 8, _hoisted_4),
                  _createElementVNode("img", {
                    src: _unref(bannerDesktop) || _unref(bannerMobile),
                    alt: ""
                  }, null, 8, _hoisted_5)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (!_unref(heading))
                ? (_openBlock(), _createElementBlock("h1", _hoisted_8, _hoisted_11))
                : (_openBlock(), _createElementBlock("h1", {
                    key: 1,
                    innerHTML: _unref(heading)
                  }, null, 8, _hoisted_12)),
              (!_unref(subheading))
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Get behind the wheel and feel the difference."))
                : (_openBlock(), _createElementBlock("p", {
                    key: 3,
                    innerHTML: _unref(subheading)
                  }, null, 8, _hoisted_14))
            ])
          ]),
          _createElementVNode("section", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (chosenTestDriveVehicle.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_unref(showVehicleDetails))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "tdl-tile-toggle",
                            "aria-controls": "tb-choose-vehicle-item",
                            "aria-pressed": !isTileHidden.value,
                            onClick: _withModifiers(handleToggleClick, ["prevent"])
                          }, [
                            _createElementVNode("span", null, _toDisplayString(isTileHidden.value ? 'Show' : 'Hide') + " Vehicle Details", 1)
                          ], 8, _hoisted_19),
                          _createElementVNode("div", {
                            id: "tb-choose-vehicle-item",
                            "aria-hidden": isTileHidden.value
                          }, [
                            _createVNode(ChooseVehicleItem, {
                              vehicle: chosenTestDriveVehicle.value,
                              imageFormat: 'jpg'
                            }, null, 8, ["vehicle"])
                          ], 8, _hoisted_20)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(DetailContactForm, {
                        modelValue: contactFormValues,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(contactFormValues) ? (contactFormValues).value = $event : null)),
                        uid: `${_unref(uid)}-3`,
                        formType: _unref(EFormType).testdrive,
                        token: _unref(token),
                        vehicle: _unref(vehicle),
                        testDriveVehicle: chosenTestDriveVehicle.value,
                        openingInfo: _unref(openingInfo),
                        theme: _unref(EFormTheme).onWhite,
                        isCustom: _unref(isCustom),
                        showGradeSelector: _unref(showGradeSelector),
                        gradeNames: _unref(gradeNames),
                        onUpdate: handleFormUpdate,
                        onStart: handleFormStart,
                        onSubmit: handleFormSubmit
                      }, {
                        thanks: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _unref(iconCircleTick),
                            role: "presentation"
                          }, null, 8, _hoisted_22),
                          _hoisted_23,
                          _hoisted_24,
                          (nviUrl.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_25, [
                                _createElementVNode("a", {
                                  class: "tb-button-solid",
                                  "data-url": nviUrl.value,
                                  onClick: _withModifiers(handleBrowseClick, ["prevent"])
                                }, "Browse " + _toDisplayString(_unref(vehicleLine)) + " Stock", 9, _hoisted_26)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "uid", "formType", "token", "vehicle", "testDriveVehicle", "openingInfo", "theme", "isCustom", "showGradeSelector", "gradeNames"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["loading"])
  ], 512))
}
}

})